"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VERSION = exports.NETWORK_ERROR = exports.REQUEST_ID = void 0;
exports.REQUEST_ID = 'qx_axios_req_id';
exports.NETWORK_ERROR = 'qx_axios_network_error';
exports.VERSION = 'v2';
//# sourceMappingURL=constants.js.map